import {InjectionToken} from '@angular/core';
import {
  authState,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  updateCurrentUser
} from '@angular/fire/auth';
import {
  collection,
  collectionData,
  doc,
  docData,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc
} from '@angular/fire/firestore';

export interface AuthInterop {
  authState: typeof authState;
  createUserWithEmailAndPassword: typeof createUserWithEmailAndPassword;
  signInWithEmailAndPassword: typeof signInWithEmailAndPassword;
  signOut: typeof signOut;
  sendPasswordResetEmail: typeof sendPasswordResetEmail;
  updateCurrentUser: typeof updateCurrentUser;
}

export interface FirestoreInterop {
  collection: typeof collection;
  collectionData: typeof collectionData;
  doc: typeof doc;
  docData: typeof docData;
  addDoc: typeof addDoc;
  setDoc: typeof setDoc;
  updateDoc: typeof updateDoc;
  deleteDoc: typeof deleteDoc;
}

export const AUTH_INTEROP = new InjectionToken<AuthInterop>('AUTH_INTEROP', {
  providedIn: 'root',
  factory: (): AuthInterop => ({
    authState,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    sendPasswordResetEmail,
    updateCurrentUser
  })
});

export const FIRESTORE_INTEROP = new InjectionToken<FirestoreInterop>('FIRESTORE_INTEROP', {
  providedIn: 'root',
  factory: (): FirestoreInterop => ({
    collection,
    collectionData,
    doc,
    docData,
    addDoc,
    setDoc,
    updateDoc,
    deleteDoc
  })
});
